import { EditorState } from 'draft-js';

export default (editorState) => {
    const currentSelection = editorState.getSelection();
    const selection = currentSelection.set('hasFocus', false);
    return EditorState.acceptSelection(editorState, selection);
};
